import uaParserJS from 'ua-parser-js';

export const state = () => ({
  name: null,
  version: null,
  os: null,
});

export const mutations = {
  set(st, data) {
    Object.assign(st, data);
  },
};

export const actions = {
  nuxtServerInit({ commit }, context) {
    const { req } = context;
    const { headers } = req;
    const { browser, os } = uaParserJS(headers['user-agent']);
    const data = { name: browser.name, version: browser.version, os: os.name };
    commit('set', data);
  },
};

export const storeModule = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default (store) => {
  store.registerModule('browser', storeModule);
};
